// 发布订阅插件
import mitt from 'mitt';

interface Bus {
  on<T>(name: string, callBack: (e?: T) => void): void;
  off<T>(name: string, call?: (e?: T) => void): void;
  emit<T>(name: string, params?: T): void;
}
const bus: Bus = mitt() as unknown as Bus;
export default bus;
